export const generatedSidecarArtifactTemplatePacket = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-sidecar-artifact-template-packet",
  "operatingRule": "Artifact templates show the exact JSON shape external workers must fill, but templates are not runtime evidence and must fail closed until replaced by real outputs.",
  "contractHash": "sha256-7c4a24f9f81457204cb8d56bf3773f1b757ad96b02af5c4cedade5f84a61a81f",
  "runSpecPacketHash": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
  "templateCount": 5,
  "blockedTemplateCount": 5,
  "evidenceBoundary": "Templates are implementation aids only. Runtime artifacts and reviewed intake reports remain the only promotable sidecar evidence.",
  "templates": [
    {
      "id": "artifact-template-spice-gf-event-window-v1",
      "contractId": "spice-gf-event-window-v1",
      "tool": "NASA NAIF SPICE Geometry Finder",
      "domain": "ephemeris-event-windows",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "templateState": "schema-template-not-runtime-evidence",
      "claimState": "cannot-promote",
      "runSpecId": "run-spec-spice-gf-event-window-v1",
      "runSpecHash": "sha256-a416865942c7d332b206a4cebcfc9068c9006dbf4222dc7dbc26437a2b986f4c",
      "outputPath": "artifacts/sidecars/spice-gf-event-window-v1.json",
      "requiredFieldCount": 16,
      "missingTemplateFields": [],
      "artifactTemplate": {
        "id": "template-spice-gf-event-window-v1",
        "contractId": "spice-gf-event-window-v1",
        "artifactState": "template-not-runtime",
        "sourceIds": [
          "spice-gf"
        ],
        "toolVersion": "<tool version>",
        "runAt": "<ISO-8601 runtime timestamp>",
        "scenarioId": "<versioned scenario id>",
        "kernelSet": [
          "<kernel or meta-kernel file>"
        ],
        "kernelHashes": {
          "<kernel-name>": "sha256-<kernel hash>"
        },
        "timeScale": "<TDB/ET/TT/UTC as applicable>",
        "gfConstraint": {
          "target": "<target>",
          "observer": "<observer>",
          "condition": "<SPICE GF condition>",
          "confinementWindow": [
            "<start TDB>",
            "<stop TDB>"
          ],
          "stepSeconds": "<numeric step seconds>"
        },
        "eventWindows": [
          {
            "eventType": "<conjunction|occultation|contact>",
            "startTdb": "<start TDB>",
            "stopTdb": "<stop TDB>",
            "durationSeconds": "<duration seconds>"
          }
        ],
        "units": [
          "<unit-1>",
          "<unit-2>"
        ],
        "uncertainty": {
          "model": "<uncertainty method>",
          "bounds": "<numeric bounds with units>"
        },
        "reproducibleCommand": "python sidecars/spice_gf/run_spice_gf.py --scenario <scenarioId> --kernel-manifest <kernelManifest.json> --constraints <constraints.json> --out artifacts/sidecars/spice-gf-event-window-v1.json",
        "inputsHash": "sha256-<input manifest hash>",
        "outputsHash": "sha256-<output payload hash>",
        "checksums": {
          "environment": "sha256-<environment lock hash>",
          "output": "sha256-<artifact file hash>"
        },
        "limitations": [
          "Replace this template text with explicit runtime limitations before intake."
        ],
        "validationStatus": "template-not-passed"
      },
      "fillInstructions": [
        "Replace every angle-bracket placeholder with runtime output or remove the artifact from intake.",
        "Set artifactState to runtime-generated only inside an actual worker run.",
        "Set validationStatus to passed only after the external tool run and independent checks have passed.",
        "Populate inputsHash, outputsHash, checksums, units, uncertainty, limitations, and source ids before intake.",
        "Run `npm run science:sidecar:intake -- <artifact.json>` and review the generated intake report before promotion."
      ],
      "promotionBoundary": "This template is a schema aid only. Submitting it unchanged must fail sidecar intake and cannot support model claims.",
      "templateHash": "sha256-7303b8f8e220915e83dc031266ee1a42616559abececbf113b3e867989730267"
    },
    {
      "id": "artifact-template-orekit-propagation-v1",
      "contractId": "orekit-propagation-v1",
      "tool": "Orekit",
      "domain": "trajectory-propagation",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "templateState": "schema-template-not-runtime-evidence",
      "claimState": "cannot-promote",
      "runSpecId": "run-spec-orekit-propagation-v1",
      "runSpecHash": "sha256-6760d4cf3d986ffb70f72246168ab2562bc9b35b7dc40400d0cba01b759d29dd",
      "outputPath": "artifacts/sidecars/orekit-propagation-v1.json",
      "requiredFieldCount": 17,
      "missingTemplateFields": [],
      "artifactTemplate": {
        "id": "template-orekit-propagation-v1",
        "contractId": "orekit-propagation-v1",
        "artifactState": "template-not-runtime",
        "sourceIds": [
          "orekit"
        ],
        "toolVersion": "<tool version>",
        "runAt": "<ISO-8601 runtime timestamp>",
        "scenarioId": "<versioned scenario id>",
        "dataContext": {
          "orekitDataHash": "sha256-<orekit-data archive hash>",
          "iersConventions": "<IERS conventions>"
        },
        "frames": [
          "<inertial frame>",
          "<body frame>"
        ],
        "timeScale": "<TDB/ET/TT/UTC as applicable>",
        "forceModel": {
          "gravity": "<gravity model>",
          "thirdBodies": [
            "<body>"
          ],
          "solarRadiationPressure": "<model>"
        },
        "events": [
          {
            "id": "<event id>",
            "epoch": "<event epoch>",
            "value": "<event value with units>"
          }
        ],
        "units": [
          "<unit-1>",
          "<unit-2>"
        ],
        "uncertainty": {
          "model": "<uncertainty method>",
          "bounds": "<numeric bounds with units>"
        },
        "reproducibleCommand": "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
        "inputsHash": "sha256-<input manifest hash>",
        "outputsHash": "sha256-<output payload hash>",
        "checksums": {
          "environment": "sha256-<environment lock hash>",
          "output": "sha256-<artifact file hash>"
        },
        "independentComparison": {
          "status": "template-not-passed",
          "referenceArtifactId": "<independent artifact id>",
          "residualBounds": "<numeric residual bounds with units>"
        },
        "limitations": [
          "Replace this template text with explicit runtime limitations before intake."
        ],
        "validationStatus": "template-not-passed"
      },
      "fillInstructions": [
        "Replace every angle-bracket placeholder with runtime output or remove the artifact from intake.",
        "Set artifactState to runtime-generated only inside an actual worker run.",
        "Set validationStatus to passed only after the external tool run and independent checks have passed.",
        "Populate inputsHash, outputsHash, checksums, units, uncertainty, limitations, and source ids before intake.",
        "Run `npm run science:sidecar:intake -- <artifact.json>` and review the generated intake report before promotion."
      ],
      "promotionBoundary": "This template is a schema aid only. Submitting it unchanged must fail sidecar intake and cannot support model claims.",
      "templateHash": "sha256-2e4b5cb2495eb0a40da7b334291976b78e0152823ebfbcc281cd125112704bfc"
    },
    {
      "id": "artifact-template-gmat-transfer-v1",
      "contractId": "gmat-transfer-v1",
      "tool": "NASA GMAT",
      "domain": "mission-design-transfer",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "templateState": "schema-template-not-runtime-evidence",
      "claimState": "cannot-promote",
      "runSpecId": "run-spec-gmat-transfer-v1",
      "runSpecHash": "sha256-0557d81b6167b827573059307a15c3621f69f6b35008f5bdef748f9280fee3d8",
      "outputPath": "artifacts/sidecars/gmat/gmat-transfer-v1.json",
      "requiredFieldCount": 18,
      "missingTemplateFields": [],
      "artifactTemplate": {
        "id": "template-gmat-transfer-v1",
        "contractId": "gmat-transfer-v1",
        "artifactState": "template-not-runtime",
        "sourceIds": [
          "gmat"
        ],
        "gmatVersion": "<GMAT version>",
        "runAt": "<ISO-8601 runtime timestamp>",
        "scenarioId": "<versioned scenario id>",
        "scriptHash": "sha256-<GMAT script hash>",
        "epoch": "<mission epoch>",
        "forceModel": {
          "gravity": "<gravity model>",
          "thirdBodies": [
            "<body>"
          ],
          "solarRadiationPressure": "<model>"
        },
        "optimizer": {
          "name": "<optimizer>",
          "settings": "<optimizer settings hash or summary>"
        },
        "trajectorySummary": {
          "departure": "<departure body/epoch>",
          "arrival": "<arrival body/epoch>",
          "deltaV": "<delta-v with units>"
        },
        "constraintSummary": {
          "status": "<constraint status>",
          "residuals": "<constraint residuals with units>"
        },
        "units": [
          "<unit-1>",
          "<unit-2>"
        ],
        "uncertainty": {
          "model": "<uncertainty method>",
          "bounds": "<numeric bounds with units>"
        },
        "reproducibleCommand": "python sidecars/gmat/run_gmat_transfer.py --scenario <scenarioId> --manifest <gmat-script-manifest.json> --report <reviewed-gmat-run-report.json> --out artifacts/sidecars/gmat/gmat-transfer-v1.json",
        "inputsHash": "sha256-<input manifest hash>",
        "outputsHash": "sha256-<output payload hash>",
        "checksums": {
          "environment": "sha256-<environment lock hash>",
          "output": "sha256-<artifact file hash>"
        },
        "independentComparison": {
          "status": "template-not-passed",
          "referenceArtifactId": "<independent artifact id>",
          "residualBounds": "<numeric residual bounds with units>"
        },
        "limitations": [
          "Replace this template text with explicit runtime limitations before intake."
        ],
        "validationStatus": "template-not-passed"
      },
      "fillInstructions": [
        "Replace every angle-bracket placeholder with runtime output or remove the artifact from intake.",
        "Set artifactState to runtime-generated only inside an actual worker run.",
        "Set validationStatus to passed only after the external tool run and independent checks have passed.",
        "Populate inputsHash, outputsHash, checksums, units, uncertainty, limitations, and source ids before intake.",
        "Run `npm run science:sidecar:intake -- <artifact.json>` and review the generated intake report before promotion."
      ],
      "promotionBoundary": "This template is a schema aid only. Submitting it unchanged must fail sidecar intake and cannot support model claims.",
      "templateHash": "sha256-0bd7273b0c919a05aef324657a34648e241593e92a3686902187a33281e14026"
    },
    {
      "id": "artifact-template-tudat-transfer-v1",
      "contractId": "tudat-transfer-v1",
      "tool": "Tudat",
      "domain": "cross-tool-trajectory-validation",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "templateState": "schema-template-not-runtime-evidence",
      "claimState": "cannot-promote",
      "runSpecId": "run-spec-tudat-transfer-v1",
      "runSpecHash": "sha256-f67dfda77ada00ef1724aa13e103ecd7be2d0e9e02418042971bc39a22369e39",
      "outputPath": "artifacts/sidecars/tudat/tudat-transfer-v1.json",
      "requiredFieldCount": 17,
      "missingTemplateFields": [],
      "artifactTemplate": {
        "id": "template-tudat-transfer-v1",
        "contractId": "tudat-transfer-v1",
        "artifactState": "template-not-runtime",
        "sourceIds": [
          "tudat"
        ],
        "toolVersion": "<tool version>",
        "runAt": "<ISO-8601 runtime timestamp>",
        "scenarioId": "<versioned scenario id>",
        "bodySettings": {
          "centralBodies": [
            "<central body>"
          ],
          "ephemerides": "<ephemeris settings>"
        },
        "integrator": {
          "type": "<integrator>",
          "tolerances": "<absolute/relative tolerances>"
        },
        "propagatorSettings": {
          "type": "<propagator>",
          "termination": "<termination settings>"
        },
        "trajectorySummary": {
          "departure": "<departure body/epoch>",
          "arrival": "<arrival body/epoch>",
          "deltaV": "<delta-v with units>"
        },
        "residualSummary": {
          "status": "<comparison status>",
          "maxResidual": "<max residual with units>"
        },
        "units": [
          "<unit-1>",
          "<unit-2>"
        ],
        "uncertainty": {
          "model": "<uncertainty method>",
          "bounds": "<numeric bounds with units>"
        },
        "reproducibleCommand": "python sidecars/tudat/run_tudat_transfer.py --scenario <scenarioId> --settings <bodySettings.json> --report <reviewed-tudat-run-report.json> --out artifacts/sidecars/tudat/tudat-transfer-v1.json",
        "inputsHash": "sha256-<input manifest hash>",
        "outputsHash": "sha256-<output payload hash>",
        "checksums": {
          "environment": "sha256-<environment lock hash>",
          "output": "sha256-<artifact file hash>"
        },
        "independentComparison": {
          "status": "template-not-passed",
          "referenceArtifactId": "<independent artifact id>",
          "residualBounds": "<numeric residual bounds with units>"
        },
        "limitations": [
          "Replace this template text with explicit runtime limitations before intake."
        ],
        "validationStatus": "template-not-passed"
      },
      "fillInstructions": [
        "Replace every angle-bracket placeholder with runtime output or remove the artifact from intake.",
        "Set artifactState to runtime-generated only inside an actual worker run.",
        "Set validationStatus to passed only after the external tool run and independent checks have passed.",
        "Populate inputsHash, outputsHash, checksums, units, uncertainty, limitations, and source ids before intake.",
        "Run `npm run science:sidecar:intake -- <artifact.json>` and review the generated intake report before promotion."
      ],
      "promotionBoundary": "This template is a schema aid only. Submitting it unchanged must fail sidecar intake and cannot support model claims.",
      "templateHash": "sha256-0491e8df008be2668c202dbef8b3bb393ddcb7a3688ea8f0d458e214d25c4995"
    },
    {
      "id": "artifact-template-openmdao-dymos-optimization-v1",
      "contractId": "openmdao-dymos-optimization-v1",
      "tool": "OpenMDAO/Dymos",
      "domain": "optimization-and-sensitivity",
      "generatedAt": "2026-06-19T00:00:00.000Z",
      "templateState": "schema-template-not-runtime-evidence",
      "claimState": "cannot-promote",
      "runSpecId": "run-spec-openmdao-dymos-optimization-v1",
      "runSpecHash": "sha256-282d8d68479110e12375b4ee39ea99c50bc9b58767b28570ab5c3c5b7a92caa0",
      "outputPath": "artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
      "requiredFieldCount": 18,
      "missingTemplateFields": [],
      "artifactTemplate": {
        "id": "template-openmdao-dymos-optimization-v1",
        "contractId": "openmdao-dymos-optimization-v1",
        "artifactState": "template-not-runtime",
        "sourceIds": [
          "openmdao",
          "dymos"
        ],
        "toolVersion": "<tool version>",
        "runAt": "<ISO-8601 runtime timestamp>",
        "scenarioId": "<versioned scenario id>",
        "problemHash": "sha256-<OpenMDAO/Dymos problem definition hash>",
        "transcription": {
          "method": "<transcription method>",
          "segments": "<segment count>"
        },
        "optimizer": {
          "name": "<optimizer>",
          "settings": "<optimizer settings hash or summary>"
        },
        "objective": {
          "name": "<objective>",
          "units": "<objective units>"
        },
        "constraints": [
          {
            "name": "<constraint>",
            "units": "<constraint units>",
            "bound": "<bound>"
          }
        ],
        "sensitivitySummary": {
          "method": "<sensitivity method>",
          "topDrivers": [
            "<driver>"
          ]
        },
        "units": [
          "<unit-1>",
          "<unit-2>"
        ],
        "uncertainty": {
          "model": "<uncertainty method>",
          "bounds": "<numeric bounds with units>"
        },
        "reproducibleCommand": "python sidecars/openmdao_dymos/run_optimization.py --problem artifacts/sidecars/openmdao_dymos/moon-logistics-beta.problem.json --out artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
        "inputsHash": "sha256-<input manifest hash>",
        "outputsHash": "sha256-<output payload hash>",
        "checksums": {
          "environment": "sha256-<environment lock hash>",
          "output": "sha256-<artifact file hash>"
        },
        "independentComparison": {
          "status": "template-not-passed",
          "referenceArtifactId": "<independent artifact id>",
          "residualBounds": "<numeric residual bounds with units>"
        },
        "limitations": [
          "Replace this template text with explicit runtime limitations before intake."
        ],
        "validationStatus": "template-not-passed"
      },
      "fillInstructions": [
        "Replace every angle-bracket placeholder with runtime output or remove the artifact from intake.",
        "Set artifactState to runtime-generated only inside an actual worker run.",
        "Set validationStatus to passed only after the external tool run and independent checks have passed.",
        "Populate inputsHash, outputsHash, checksums, units, uncertainty, limitations, and source ids before intake.",
        "Run `npm run science:sidecar:intake -- <artifact.json>` and review the generated intake report before promotion."
      ],
      "promotionBoundary": "This template is a schema aid only. Submitting it unchanged must fail sidecar intake and cannot support model claims.",
      "templateHash": "sha256-8dd9c9a49f2bef742bfa1207bf07c4ae921c1f4fcd253810df170e07d03e47b3"
    }
  ],
  "packetHash": "sha256-1d12bee590730603b7885e3df87ac787e8ff9b93a104a4227321245507a86d86"
}
;
